export const advisorOptions = state => state.options.advisor
export const hasError = state => state.auth.additionalAdvisorsSet.hasError || state.auth.settingSet.hasError
export const isPending = state => state.auth.additionalAdvisorsSet.isPending || state.auth.settingSet.isPending
export const user = state => state.auth.user
